import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

export interface DropdownProps {
    triggerLabel?: string;
    onOpen?: () => void;
    onClose?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    triggerLabel: { default: 'Acciones' },
    onOpen: null,
    onClose: null
  },
  setup(__props: any, { expose }) {

const props = __props as { triggerLabel: string, onOpen?: () => void, onClose?: () => void };



const isOpen = ref(false);

const toggleDropdown = () => {
    if (isOpen.value) {
        closeDropdown();
    } else {
        openDropdown();
    }
};

const openDropdown = () => {
    isOpen.value = true;
    props.onOpen ? props.onOpen() : null;
};

const closeDropdown = () => {
    isOpen.value = false;
    props.onClose ? props.onClose() : null;
};

// Cerrar al clickear fuera
const handleClickOutside = (event: MouseEvent) => {
    const dropdown = document.querySelector('.dropdown');
    if (dropdown && !dropdown.contains(event.target as Node)) {
        closeDropdown();
    }
};

// Listeners para cerrar al clickear items
const handleItemClick = () => {
    closeDropdown();
};

expose({
    isOpen,
    toggle: toggleDropdown,
    open: openDropdown,
    close: closeDropdown,
});

return { __sfc: true,props, isOpen, toggleDropdown, openDropdown, closeDropdown, handleClickOutside, handleItemClick }
}

})